import React, { Component} from 'react'
import logo from "../../assets/logo_espol_interno.svg";
import equis from "../../assets/eliminar.svg"
import check from "../../assets/check.svg";
import info from "../../assets/Info.png"
import "../../css/FormRegistro.css";
import axios from 'axios';
import FormRegistroContrasenia from './FormRegistroContrasenia';
import Modal from './Modal';
import Header from '../components/Header.js';
import CenteredWrapper from '../components/CenteredWrapper.js'
import Footer from '../components/Footer.js';
import anuncio from "../../assets/Anuncio.svg";
import anuncioico from "../../assets/AnuncioICO.svg";
import Acuerdo from './Acuerdo.js';
import BotonExpandible from "../components/BotonExpandible";
import RadioSwitch from "../components/RadioSwitch";
import jwt from 'jwt-decode'
import { useNavigate,Navigate} from "react-router-dom";


export class FormRegistro extends Component {

    constructor(props){
        super(props);

        this.state={
            verFormRegistroContrasenia: false,
            verAcuerdo: false,
            verMensajeConocimiento: false,
            modalError:false,
            modalIsOpen:false,
            modalMensaje: "",
            mensaje_error_alias:"",
            datosUsuario:{
                id:this.props.id,
                identificacion:this.props.identificacion,
                nombres:this.props.nombres,
                apellidos: this.props.apellidos,
                alias_sugerido: this.props.alias_sugerido,
                usuarioEscogido:this.props.usuarioEscogido,
                listaUsuarios: this.props.usuarios,
                correoAlterno: this.props.correoAlterno,
                rol: this.props.rol,
                telefono: this.props.telefono,
                unidad: this.props.unidad,
            },
            expresiones:{
                alias_sugerido: /^[a-z]+[/.][a-z]+$/,
            },
            errorSolicitud:{
                alias_sugerido:""
            },
            modalSugerencia: {
                show: false,
                titulo: "Sugerencia de Alias",
                mensaje: "Los alias que te sugerimos utilizar es este:",
                imagen: info,
                listSug: [],
            },
            listSugerencia: [],
            activebutton: true,
            token_nueva_cuenta: sessionStorage.getItem("token_nueva_cuenta"),
            tiempoRestante:"",
            redirectInicio:false,
        };
        

        this.renderFormRegistroContrasenia=this.renderFormRegistroContrasenia.bind(this);
        this.abrirModalInfoGTSI=this.abrirModalInfoGTSI.bind(this);
        this.cerrarModalInfoGTSI=this.cerrarModalInfoGTSI.bind(this);

        this.abrirModalError=this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.cerrarModalSesionExpirada = this.cerrarModalSesionExpirada.bind(this);


        this.abrirModalSugerencia = this.abrirModalSugerencia.bind(this);
        this.cerrarModalSugerencia = this.cerrarModalSugerencia.bind(this);

        this.abrirMensajeconocimiento = this.abrirMensajeconocimiento.bind(this);

        this.abrirAcuerdo = this.abrirAcuerdo.bind(this);

        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);
    }

    
    obtenerTime() {
        const token = this.state.token_nueva_cuenta;
        const tokendecode = jwt(token);

        const exp = tokendecode.exp; // segundos UNIX
        const fechaExpiracion = new Date(exp * 1000); // UTC → Date válido

        // Limpiar timer anterior
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }

        // Iniciar cuenta regresiva
        this.timerInterval = setInterval(() => {
            const ahora = new Date();
            const diff = fechaExpiracion - ahora;

            if (diff <= 0) {
                clearInterval(this.timerInterval);
                this.setState({ 
                    tiempoRestante: "Sesión expirada",
                    redirectInicio:true,
                 });
                // Aquí puedes cerrar sesión automáticamente

            } else {
                const horas = Math.floor(diff / (1000 * 60 * 60));
                const minutos = Math.floor((diff / (1000 * 60)) % 60);
                const segundos = Math.floor((diff / 1000) % 60);

                const tiempo =
                    `${horas.toString().padStart(2, "0")}:` +
                    `${minutos.toString().padStart(2, "0")}:` +
                    `${segundos.toString().padStart(2, "0")}`;

                this.setState({ tiempoRestante: tiempo });
            }
        }, 1000);
    }

    componentWillMount() {
        //this.props.useEffect();
        this.obtenerTime();
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });

    }
    abrirAcuerdo() {
        this.setState({ verAcuerdo: true });
        //console.log("Ver Acuerdo");
    }

    abrirMensajeconocimiento() {
        this.setState({ verMensajeConocimiento: true })
    }

    abrirModalSugerencia() {
        this.setState({
            modalSugerencia: {
                ...this.state.modalSugerencia,
                show: true
            }
        });
    }

    cerrarModalSugerencia() {
        this.setState({
            modalSugerencia: {
                titulo: "",
                mensaje: "",
                imagen: "",
                listSug: [],
                show: false
            }
        });
        //console.log("cerrar modal " + this.state.modalVerificar);
    }

    abrirModalError(){
        this.setState({modalError:true});
    }

    cerrarModalError(){
        this.setState({modalError:false})
    }

     cerrarModalSesionExpirada(){
           window.location.href = "/inicio";
    }

    renderFormRegistroContrasenia(valor){
        //console.log("cambio->" , valor);
        //console.log(this.state.datosUsuario);
        this.setState({verFormRegistroContrasenia:valor})
    }



    postVerificarAlias =async(e)=>{
        e.preventDefault();
        this.disabledbuttonf();
        
        var datos = {
            alias: this.state.datosUsuario.alias_sugerido,
            nombres: this.state.datosUsuario.nombres,
            apellidos: this.state.datosUsuario.apellidos
        }
        axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario/verificaralias`, datos,
            {
                headers: {
                    Authorization: `Bearer ${this.state.token_nueva_cuenta}`
                }
            }  
        )
        .then(r => {

            if (r.data.success) {
                this.state.mensaje_error_alias = r.data.message;
                if (r.data.message === "El alias ingresado no tiene relación con el nombre o el apellido" || r.data.message === "No se ha podido recomendar un alias. Revise que sus nombres y Apellidos esten completos") {
                    //console.log("existe alias");
                    this.state.listSugerencia = [];
                    this.setState({
                        modalSugerencia: {
                            show: true,
                            titulo: "Sugerencia de alias",
                            mensaje: this.state.mensaje_error_alias,
                            imagen: info,
                            listSug: this.state.listSugerencia,
                        }
                    });
                } else if (r.data.message === "El alias que ingreso ya se encuentra siendo utilizado. Le sugerimos que utilice el siguientes alias:") {
                    this.state.listSugerencia = r.data.lSugerencia;
                    this.setState({
                        modalSugerencia: {
                            show: true,
                            titulo: "Sugerencia de alias",
                            mensaje: this.state.mensaje_error_alias,
                            imagen: info,
                            listSug: this.state.listSugerencia,
                        }
                    });
                } 
            } else {
                this.abrirAcuerdo();
            }
            this.activebuttonf();
        })
        .catch(error=>{
            this.setState({ modalMensaje: error.response.data.errorMessage })
            this.abrirModalError();
            this.activebuttonf();
        });    
    }

    abrirModalInfoGTSI(){
        this.setState({modalIsOpen:true});
    }

    cerrarModalInfoGTSI(){
        this.setState({modalIsOpen:false});
    }
    
    handlerDatosFormRegistro=async(e)=>{
        await this.setState({
            datosUsuario:{
                ...this.state.datosUsuario,
                [e.target.name]:e.target.value,
            }
        })
        this.handlerOnBlur();
    }

    handlerOnBlur=async()=>{

        if(this.state.datosUsuario.alias_sugerido===""){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                alias_sugerido: "El campo 'Alias sugerido' es requerido"
            }})
        } else if (!this.state.expresiones.alias_sugerido.test(this.state.datosUsuario.alias_sugerido.toLowerCase())){
            await this.setState({errorSolicitud:{
                ...this.state.errorSolicitud,
                alias_sugerido: "El campo 'Alias sugerido' solo acepta entradas de este tipo: nombre.apellido",
            }})
        }else{
            this.setState({errorSolicitud:{                
                ...this.state.errorSolicitud,
                alias_sugerido:""
            }})
        }
    }


    render() {  
        if(this.state.redirectInicio){
            return (
                <Modal cerrarModal={this.cerrarModalSesionExpirada} verBoton={true} textoBoton="ACEPTAR" >
                    <p className='text-center'><strong>Sesión expirada</strong></p>
                    <div className='mt-6 mb-6'>
                        <img className="registro-check" src={equis} alt="Error"></img>
                    </div>
                    <p className='text-center'>Será redireccionado a la página de inicio.</p>
                </Modal>
            ) 
        }
       
        return (
            <>
            <Header
                ifShowTime={true}
                tiempoRestante={this.state.tiempoRestante}
            />
            {this.state.verAcuerdo ? (
                <Acuerdo
                    identificacion={this.state.datosUsuario.identificacion}
                    nombres={this.state.datosUsuario.nombres}
                    apellidos={this.state.datosUsuario.apellidos}
                    alias_sugerido={this.state.datosUsuario.alias_sugerido}
                    usuario_sugerido={this.state.datosUsuario.usuarioEscogido}
                    correoAlterno={this.state.datosUsuario.correoAlterno}
                    rol={this.state.datosUsuario.rol}
                    telefono={this.state.datosUsuario.telefono}
                    unidad={this.state.datosUsuario.unidad}
                    tipoForm={"A"}
                    mensaje_titulo="CREAR CUENTA"
                    verbtngeneral={false}
                    verbtngeneralElectronica={true}
                    callTagManager={this.props.callTagManager}
                   /* useEffect={this.props.useEffect}*/
                    showHeader={false}
                />
                )
                : 
                (
                    <div >   
                        <CenteredWrapper>
                            <div className="registro-container">
                                <div className="container">
                                    <div className="row">
                                        <BotonExpandible 
                                            mensaje={
                                            <div style={{ textAlign: "left" }}>
                                                <strong>
                                                    Si la información presentada no es correcta por favor contactarse con{" "}
                                                    <a href="mailto:gerenciatecnologia@espol.edu.ec">
                                                    gerenciatecnologia@espol.edu.ec
                                                    </a>
                                                </strong>
                                                <br /><br />
                                                <em style={{ fontWeight: 200 }}>
                                                    El campo Alias sugerido es un identificador adicional de la cuenta, solo
                                                    sirve para que otras personas puedan enviarte correos electrónicos.
                                                </em>
                                            </div>
                                                                                                                                    
                                            }
                                        />
                                    </div>
                                    <div className="row">
                                        <div className="col-12 ">
                                            <p className="registro-title">CREAR CUENTA</p>
                                        </div>
                                    </div>

                                    <div className='row-form-e'>
                                        <div className="row-form-datos-e col-10">
                                            <div className="col-12 col-md-12 col-xl-11 mt-2" >
                                                <label htmlFor="identificacion" id="registro-textoLabel">IDENTIFICACIÓN </label>
                                                <input className="form-control" type="text" name="identificacion" defaultValue={this.state.datosUsuario.identificacion} disabled></input>
                                            </div>

                                            <div className="col-12 col-md-12 col-xl-11  mt-2"  >
                                                <label id="registro-textoLabel" htmlFor="nombres">NOMBRE(S) </label>
                                                <input className="form-control" type="text" name="nombres" defaultValue={this.state.datosUsuario.nombres.toUpperCase()} disabled></input>
                                            </div>

                                            <div className="col-12 col-md-12 col-xl-11 mt-2" >
                                                <label id="registro-textoLabel" htmlFor="apellidos">APELLIDO(S) </label>
                                                <input className="form-control" type="text" name="apellidos" defaultValue={this.state.datosUsuario.apellidos.toUpperCase()} disabled></input>
                                            </div>

                                            <div className="col-12 col-md-12 col-xl-11 mt-2">

                                                <label id="registro-textoLabel" htmlFor="alias_sugerido">ALIAS SUGERIDO: </label>
                                                {/* <label className="sr-only" htmlFor="alias_sugerido"></label> */}

                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                            className={this.state.errorSolicitud.alias_sugerido ? "form-control olvidoContra-input-error" : "form-control"}
                                                        id="alias"
                                                        placeholder="nombre.apellido"
                                                            name="alias_sugerido"
                                                            defaultValue={this.state.datosUsuario.alias_sugerido}
                                                        value={this.state.datosUsuario.alias_sugerido}
                                                        onChange={this.handlerDatosFormRegistro}
                                                        onBlur={this.handlerOnBlur}
                                                    />
                                                    <div id="registro-textoLabel" className="input-group-text" style={{ backgroundColor: "#E9ECEF" }}>@espol.edu.ec</div>
                                                </div>

                                                {this.state.errorSolicitud.alias_sugerido &&
                                                    <p className='solicitud-leyenda'>{this.state.errorSolicitud.alias_sugerido}</p>
                                                }
                                            </div>

                                        </div>
                                    
                                        <br/>

                                        <div className="row-seleccion-usuario">                                                                            
                                            <div className="row-seleccion-usuario-texto mt-4">
                                                <label id="registro-textoLabel" >SELECCIONE UN USUARIO: </label>
                                                {/* <p align="justify" className='solicitud-infor'>El campo "Usuario sugerido" es el identificador que deberá usar para acceder a los sistemas de la ESPOL.</p> */}
                                            </div>

                                            <div className="row-seleccion-usuario-opciones">
                                                <div className="col-xl-12 mt-3 usuarios">
                                                    {this.state.datosUsuario.listaUsuarios.map((value, index) => {
                                                        return (
                                                            <div className="form-check" key={index}>
                                                                <input className="form-check-input"
                                                                    type="radio" name="usuarioEscogido"
                                                                    id="usuarioEscogido" value={value}
                                                                    onClick={this.handlerDatosFormRegistro}
                                                                />
                                                                <label className="form-check-label" htmlFor="usuarioEscogido">{value}</label>
                                                            </div>
                                                        );
                                                    })}
                                                    {/* {this.state.datosUsuario.listaUsuarios.map((value, index) => {
                                                        return (
                                                            <RadioSwitch
                                                                key={index}
                                                                name="usuarioEscogido"
                                                                value={value}
                                                                label={value}
                                                                checked={this.state.usuarioEscogido === value}
                                                                onChange={(val) => {
                                                                    this.setState({ usuarioEscogido: val });
                                                                    this.handlerDatosFormRegistro(val); // llamas tu handler
                                                                }}
                                                            />
                                                        );
                                                    })} */}
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    
                                    
                                    <br/>
                                    {/* <br /> */}

                                    <div className="registro-container-botonGuardar">
                                        <button
                                            disabled={
                                                this.state.datosUsuario.identificacion &&
                                                    this.state.datosUsuario.nombres &&
                                                    this.state.datosUsuario.apellidos &&
                                                    this.state.datosUsuario.alias_sugerido &&
                                                    this.state.datosUsuario.usuarioEscogido &&
                                                    !this.state.errorSolicitud.alias_sugerido &&
                                                    this.state.activebutton
                                                    ? false : true}
                                            type="submit"
                                            className={
                                                this.state.datosUsuario.identificacion &&
                                                    this.state.datosUsuario.nombres &&
                                                    this.state.datosUsuario.apellidos &&
                                                    this.state.datosUsuario.alias_sugerido &&
                                                    this.state.datosUsuario.usuarioEscogido &&
                                                    !this.state.errorSolicitud.alias_sugerido &&
                                                    this.state.activebutton

                                                    ?
                                                    "registro-btn-submit" : "registro-btn-submit-disabled"}
                                            onClick={this.postVerificarAlias}>SEGUIR
                                        </button>

                                        {!this.state.activebutton ?
                                            <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                            : null}

                                    </div>
                                </div>
                            </div>
                        </CenteredWrapper>
                        <Footer />

                        {this.state.modalIsOpen&& 
                        <Modal isOpen={this.state.modalIsOpen} cerrarModal={this.cerrarModalInfoGTSI} verBoton={false}>
                            <p className="text-justify">
                            Comunicarse con la Gerencia de Tecnologías y Servicios de Información</p>
                            <p><strong>Teléfono: </strong>(+593)42269256</p>
                            <p><strong>Atención: </strong>Lunes a Viernes de 08:00 a 16:00</p>
                            <p>gerenciatecnologia@espol.edu.ec</p>
                        </Modal>}

                        {this.state.modalError&& 
                            <Modal isOpen={this.state.modalError} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>Error en la Solicitud</strong></p>
                                <div className='mt-6 mb-6'>
                                    <img className="registro-check" src={equis} alt="Error"></img>
                                </div>
                                <p className='text-center'>{this.state.modalMensaje}</p>
                            </Modal>
                        }

                        {this.state.modalSugerencia.show &&
                            <Modal isOpen={this.state.modalSugerencia.show} cerrarModal={this.cerrarModalSugerencia} verBoton={true} textoBoton="ACEPTAR" >
                                <p className='text-center'><strong>{this.state.modalSugerencia.titulo}</strong></p>
                                <div className='mt-6 mb-6'>
                                    <img className="registroContra-check" src={this.state.modalSugerencia.imagen} alt="Exitoso"></img>
                                </div>

                                <p className='text-center'>{this.state.modalSugerencia.mensaje}</p>
                                <div className="divCentrar">
                                    <ul className='solicitud-menulist' >
                                        <b>{this.state.modalSugerencia.listSug.map((sugerencia) => <li>{sugerencia}</li>)}</b>
                                    </ul>
                                </div>
                            </Modal>
                        }       
                    </div>
                )
            }  
            </>     
        )
    }
}

export default FormRegistro
